import styled from '@emotion/styled';

const FilterHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const TableWrapper = styled.div`
  width: 400px;
  height: 400px;
  overflow-y: auto;
`;

export { FilterHeader, TableWrapper };
